module.exports = __webpack_public_path__ + "assets/rewind.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/video/rewind.svg
// module id = 454
// module chunks = 19